//main
import ContentFormatXX from '../content/webc/content-format-xx';

import WebbDividerSmall from "../content/webb/webb-divider-sm";
import HeaderSectionDark from "../content/webb/head-section-dark";

import EventsViewModule from '../content/events/events-view';

import { UserForm } from "../services/srvc-utilities";

export default function EventsView() {

  return (
  <>
    <ContentFormatXX 
      head='View Event Details'
      link={`/${UserForm()}/events`}
      form= 'small'
      data= {
        <>
          <WebbDividerSmall />
          <EventsViewModule />


        </>
      } 
    />
  </>
  )
}